import { extractLovListRows } from './normalize'

/** 用项目 HttpRequest 等封装 LOV 编辑弹窗列表请求 */
export function createLovListFetcher(
  request: (lovType: string) => Promise<unknown>
): (lovType: string) => Promise<Record<string, unknown>[]> {
  return async (lovType) => {
    if (!lovType) {
      return []
    }
    const data = await request(lovType)
    return extractLovListRows(data, lovType)
  }
}
